import React, { useState } from "react";

import {
  FaTag,
  FaShieldAlt,
  FaCar,
  FaClock,
} from "react-icons/fa";

import {
  FaCheckDouble
} from "react-icons/fa6";


const WhyChooseSection = () => {


  const [activeIndex, setActiveIndex] = useState(0);



  const accordionItems = [

    {
      icon: <FaTag />,
      title: "Affordable & Transparent Pricing",
      description:
        "Shreesha Tours & Travels provides clear and affordable cab pricing with no hidden charges. Enjoy comfortable journeys at the best available rates.",
      features: [
        "No hidden charges",
        "Competitive taxi fares",
        "Multiple vehicle options",
        "Easy booking process",
      ],
    },


    {
      icon: <FaShieldAlt />,
      title: "Safe & Reliable Travel",
      description:
        "Your safety is our priority. Our experienced drivers and well-maintained vehicles ensure a secure and comfortable journey.",
      features: [
        "Experienced professional drivers",
        "Clean and sanitized vehicles",
        "Safe driving practices",
        "24×7 customer support",
      ],
    },


    {
      icon: <FaCar />,
      title: "Wide Range of Vehicles",
      description:
        "Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta and luxury vehicles according to your travel requirements.",
      features: [
        "Sedan cars available",
        "SUV and MUV options",
        "Premium Innova Crysta",
        "Family and group travel vehicles",
      ],
    },


    {
      icon: <FaClock />,
      title: "24×7 Cab Availability",
      description:
        "Book Shreesha Tours & Travels anytime for airport transfers, outstation trips, corporate travel and pilgrimage tours.",
      features: [
        "Round the clock booking",
        "Airport pickup & drop",
        "One way and round trip cabs",
        "On-time service",
      ],
    },

  ];






  const toggleAccordion = (index) => {

    setActiveIndex(
      activeIndex === index ? -1 : index
    );

  };






  return (

    <section className="why-section">


      <div className="why-container">


        <div className="why-grid">





          {/* Left Content */}

          <div className="why-content">



            <span className="why-heading">

              Why Choose Shreesha Tours & Travels

            </span>




            <h2>

              Experience comfortable, safe and reliable cab services
              with professional drivers and well-maintained vehicles
              for every journey.

            </h2>






            <div className="why-images">





              <div className="experience-box">

                <div>
                  15<span>+</span>
                </div>


                <p>
                  Years of Excellence
                </p>


              </div>





              <div className="image-one">

                <img

                  src="/images/why-choose-us4.jpg"

                  alt="Shreesha Tours and Travels"

                />

              </div>






              <div className="image-two">

                <img

                  src="/images/why-choose-us5.jpg"

                  alt="Cab Service"

                />

              </div>




            </div>




          </div>









          {/* Accordion */}


          <div className="accordion">



          {

          accordionItems.map((item,index)=>(


            <div

              className="accordion-item"

              key={index}

            >





              <button

                className="accordion-button"

                onClick={()=>toggleAccordion(index)}

              >




                <span className="accordion-title">



                  <span className="icon-box">

                    {item.icon}

                  </span>




                  {item.title}



                </span>






                <span className="toggle-icon">


                  <i className={

                    activeIndex === index

                    ? "ri-subtract-line"

                    : "ri-add-fill"

                  }></i>


                </span>




              </button>








              {

              activeIndex === index &&


              <div className="accordion-content">



                <p>

                  {item.description}

                </p>





                <ul>


                {

                item.features.map((feature,i)=>(


                  <li key={i}>


                    <FaCheckDouble />


                    {feature}



                  </li>


                ))

                }


                </ul>




              </div>


              }




            </div>


          ))

          }





          </div>





        </div>


      </div>


    </section>


  );


};



export default WhyChooseSection;